import { render, staticRenderFns } from "./ContactBanner.vue?vue&type=template&id=21b27b06&scoped=true"
import script from "./ContactBanner.vue?vue&type=script&lang=ts"
export * from "./ContactBanner.vue?vue&type=script&lang=ts"
import style0 from "./ContactBanner.vue?vue&type=style&index=0&id=21b27b06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b27b06",
  null
  
)

export default component.exports